import tmdb from './client';

const MovieID = (id, config = {}) =>
  tmdb.get(`/movie/${id}`, {
    ...config,
    params: { language: 'en-US', ...(config.params || {}) },
  });

export default MovieID;
